export const VACANCY_CREATE_MODAL_NAME = 'vacancyCreate';
